export default "__VITE_ASSET__DDr2GMIz__"